/*=========================================================================================
  File Name: module-mws-actions.js
  Description: MWS Module Actions — gọi API lấy token kết nối broker
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import MwsAPI from '@/api/mws.js';

export default {
	/**
	 * Lấy token MWS từ BE (GET api/mws/token).
	 * TaxCode lấy từ JWT claim phía BE — client không truyền room.
	 * Trả về MWSTokenResponse { Token, BrokerUrl, TokenExpiredSecond } hoặc null.
	 */
	getTokenFromMWS: async function(context) {
		let res = await httpClient.getAsync({
			url: MwsAPI.getAPIUrl() + '/token'
		});

		if (res && res.Success && res.Data) {
			return res.Data;
		}

		return null;
	},

	/**
	 * Xóa cache token MWS — gọi khi đổi MST làm việc (token gắn theo TaxCode)
	 */
	clearMWSToken: function(context) {
		context.commit('resetState');
	}
};
